// css
import '../css/lightSide.less';

import './site/jQuery.lightSide';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index-lightSide.js